import type { Job } from "../types/job";

export type JobsStatusFilter = "all" | "published" | "draft";
export type JobsTriggerFilter = "schedule" | "webhook";

export interface JobsFilterState {
  query: string;
  status: JobsStatusFilter;
  /** Vazio = qualquer gatilho. */
  triggers: JobsTriggerFilter[];
}

export const EMPTY_JOBS_FILTER: JobsFilterState = { query: "", status: "all", triggers: [] };

export function isEmptyJobsFilter(filter: JobsFilterState): boolean {
  return filter.query.trim() === "" && filter.status === "all" && filter.triggers.length === 0;
}

function normalize(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/**
 * Os jobs que passam no filtro da tela (AB#86605). A busca olha nome, descrição
 * e instrução — é na instrução que a Skill aparece, então procurar pelo nome da
 * Skill encontra os jobs que a seguem. Sem acento e sem caixa: "reuniao" acha
 * "Reunião".
 */
export function filterJobs(jobs: Job[], filter: JobsFilterState): Job[] {
  const terms = normalize(filter.query).split(/\s+/).filter(Boolean);
  return jobs.filter((job) => {
    if (filter.status === "published" && !job.published) return false;
    if (filter.status === "draft" && job.published) return false;
    if (filter.triggers.length > 0 && !filter.triggers.includes(job.trigger.type)) return false;
    if (terms.length === 0) return true;
    const haystack = normalize([job.name, job.description, job.instruction].filter(Boolean).join(" "));
    return terms.every((term) => haystack.includes(term));
  });
}
